// Is a given value a DOM element?
export default function isElement(obj) {
  return !!(obj && obj.nodeType === 1);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/underscore/modules/isElement.js
// module id = 206
// module chunks = 0 1